import {
  ConditionType,
  generateUniqueId,
} from "@erelego/design-system/components/molecules/ConditionFilters/utils";
import {
  IFieldLevelRuleClient,
  IFieldLevelRuleConditionMap,
  IFieldLevelRuleConditionServer,
} from "./interface";
import { IConditionDetails } from "./useGroupFilter";
import { uniqueIdType } from "@erelego/design-system/components/molecules/ConditionFilters/interface";
import {
  IFieldLevelRuleServer,
} from "@erelego/design-system/interface/Forms/formRulesInterface";


const fieldRuleClient: IFieldLevelRuleClient = {
  ruleId: generateUniqueId(uniqueIdType.RULE),
  ruleName: "",
  logicalOperator: "or",
  checkFieldRuleValidation: false,
  fieldConditionIds: [],
  fieldsUsedInAction: [],
};
const initialFieldCondition = {};

export const fieldCondition = {
  formId: "",
  fieldConditionMap: {
    "condition-id-901335bb-6950-47f6-bc46-da335b32e1f1": {
      fieldConditionId: "condition-id-901335bb-6950-47f6-bc46-da335b32e1f1",
      operator: "IS",
      value: "ccsdf",
      fieldType: "TEXT_INPUT",
      fieldLocalId:
        "_6613d15f2521d250ccf2d3b4_field_id_c7b13217_5f79_40d3_b701_f6da02559897",
      subFormLocalId:
        "_6613d15f2521d250ccf2d3b4_section_id_8e39154f_fb21_48f9_b249_97cb755403ca",
      fieldConditionIds: [],
      conditionName: "R1",
      conditionType: "form_field",
      fieldValueType: "custom_field",
    },
    "sub-rule-idaa477065-6b5a-45b2-ad86-fa926760dcc9": {
      logicalOperator: "or",
      fieldConditionIds: ["condition-id-901335bb-6950-47f6-bc46-da335b32e1f1"],
      fieldConditionId: "sub-rule-idaa477065-6b5a-45b2-ad86-fa926760dcc9",
    },
  },
  activeFieldRuleCount: 1,
  fieldRules: [
    {
      ruleId: "rule-id-a874b3c3-d398-4b9e-9253-fab59994982d",
      ruleName: "",
      logicalOperator: "or",
      checkFieldRuleValidation: false,
      fieldConditionIds: ["sub-rule-idaa477065-6b5a-45b2-ad86-fa926760dcc9"],
      fieldsUsedInAction: [],
    },
  ],
  pageRules: [],
  formRules: [],
  submissionRules: [],
  fieldsToHideAndShow: {
    hide: [],
    show: [],
  },
  pageToHideAndShow: {
    show: [],
    skip: [],
    elseSkip: [],
    hide: [],
  },
};
export interface IConditionDataServerConvertedData {
  fieldConditionMap: IFieldLevelRuleConditionMap;
  fieldRules: IFieldLevelRuleClient[];
}
export const getInitialValue = (
  serverData: IConditionDataServerConvertedData
): IConditionDetails => {
  const serverFieldRule =
    serverData.fieldRules.length > 0
      ? serverData.fieldRules
      : [fieldRuleClient];
  const initialConditionData: IConditionDetails = {
    formId: "",
    fieldConditionMap: serverData?.fieldConditionMap ?? {},
    activeFieldRuleCount: 0,
    fieldRules: serverFieldRule,
    pageRules: [],
    formRules: [],
    submissionRules: [],
    fieldsToHideAndShow: {
      hide: [],
      show: [],
    },
    pageToHideAndShow: {
      show: [],
      skip: [],
      elseSkip: [],
      hide: [],
    },
  };
  return initialConditionData;
};
// export const initialConditionData: IConditionDetails = {
//   formId: "",
//   fieldConditionMap: {},
//   activeFieldRuleCount: 0,
//   fieldRules: [fieldRuleClient],
//   pageRules: [],
//   formRules: [],
//   submissionRules: [],
//   fieldsToHideAndShow: {
//     hide: [],
//     show: [],
//   },
//   pageToHideAndShow: {
//     show: [],
//     skip: [],
//     elseSkip: [],
//     hide: [],
//   },
// };

const getConditionsData = (
  conditionIds: string[],
  conditionMap: IFieldLevelRuleConditionMap
): IFieldLevelRuleConditionServer[] => {
  const fieldConditionServer: IFieldLevelRuleConditionServer[] = [];
  for (const index in conditionIds) {
    const conditionId = conditionIds[index];
    const fieldConditionData = { ...(conditionMap[conditionId] ?? {}) };

    const {
      logicalOperator,
      fieldConditionIds = [],
      operator,
      value,
      fieldType,
      fieldLocalId,
      subFormLocalId,
      fieldValueType,
      conditionType,
    } = fieldConditionData;
    const fieldConditionsServer: IFieldLevelRuleConditionServer[] =
      getConditionsData(fieldConditionIds, conditionMap);

    let updatedValue: any = value ?? "";
    let isLocalId = false;
    if (fieldValueType == ConditionType.form_field) {
      isLocalId = true;
      if (
        typeof updatedValue === "object" &&
        updatedValue !== null &&
        "value" in updatedValue
      ) {
        updatedValue = (updatedValue as { value: any }).value;
      }
    } else {
      if (
        typeof updatedValue === "object" &&
        updatedValue !== null &&
        "value" in updatedValue
      ) {
        updatedValue = (updatedValue as { value: any }).value;
      }
    }

    const fieldConditionDataServer: IFieldLevelRuleConditionServer = {
      logicalOperator,
      operator,
      value: updatedValue,
      fieldType,
      fieldLocalId,
      subFormLocalId,
      fieldValueType: fieldValueType ?? "",
      conditions: fieldConditionsServer,
      conditionType: conditionType,
      // conditionName,
    };
    fieldConditionServer.push(fieldConditionDataServer);
  }
  return fieldConditionServer;
};

export const getFieldRuleDataServerFormat = (
  fieldRuleClient: IFieldLevelRuleClient,
  fieldConditionMap: IFieldLevelRuleConditionMap
): IFieldLevelRuleServer => {
  const {
    ruleName = "",
    logicalOperator,
    fieldConditionIds = [],
  } = fieldRuleClient;
  const fieldConditionsServer: IFieldLevelRuleConditionServer[] =
    getConditionsData(fieldConditionIds, fieldConditionMap);
  const fieldRuleServer: IFieldLevelRuleServer = {
    ruleName,
    logicalOperator,
    conditions: fieldConditionsServer,
  };

  return fieldRuleServer;
};
